import React from 'react';
import { IntlProvider } from 'react-intl';
import memoize from 'lodash/memoize';
import get from 'lodash/get';
import { flatten, normalizeLocale } from '../helpers';
import { withTranslateContext } from './TranslateContext';
// this memoization saves up to 0.5ms on _each_ render cycle
const getFlatMessages = memoize((translations) => memoize((path) => flatten(get(translations, path, translations))));
export const _TranslateScope = (props) => {
    const { translationsContext, path, children } = props;
    const translations = translationsContext.translations || { locale: 'de' };
    const messages = getFlatMessages(translationsContext.translations)(path);
    const normalisedLocale = normalizeLocale(translations.locale);
    return (React.createElement(IntlProvider, { locale: normalisedLocale, messages: messages }, children));
};
export const TranslateScope = withTranslateContext(_TranslateScope);
export function withTranslateScope(WrappedComponent, scopeName) {
    return (props) => (React.createElement(TranslateScope, { path: scopeName },
        React.createElement(WrappedComponent, { ...props })));
}
//# sourceMappingURL=TranslateScope.js.map